module.exports = __webpack_public_path__ + "img/remove-fav.a1b9cb13.svg";